export const getTargetOrigin = () => {
    if (process.env.CYBERSOURCE_ORIGIN) {
        return process.env.CYBERSOURCE_ORIGIN;
    }
    if (process.env.NODE_ENV === 'development') {
        return 'https://localhost:3443';
    }
    return null;
};
